import { render, staticRenderFns } from "./MuralPicker.vue?vue&type=template&id=4e03a1ab&"
import script from "./MuralPicker.vue?vue&type=script&lang=js&"
export * from "./MuralPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports